// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3ya4s","header":"Messages_header__26sv4"};